module.exports = __webpack_public_path__ + "static/media/experimentation.18ecfc43.png";